var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.2385 3.62081C12.9358 3.31799 12.5765 3.07778 12.1809 2.91389C11.7854 2.75 11.3615 2.66565 10.9333 2.66565C10.5052 2.66565 10.0812 2.75 9.68571 2.91389C9.29018 3.07778 8.93082 3.31799 8.62815 3.62081L8 4.24895L7.37185 3.62081C6.76048 3.00943 5.93128 2.66597 5.06666 2.66597C4.20205 2.66597 3.37285 3.00943 2.76148 3.62081C2.15011 4.23218 1.80664 5.06138 1.80664 5.92599C1.80664 6.7906 2.15011 7.6198 2.76148 8.23118L3.38963 8.85932L8 13.4697L12.6104 8.85932L13.2385 8.23118C13.5413 7.92851 13.7815 7.56914 13.9454 7.17361C14.1093 6.77808 14.1937 6.35413 14.1937 5.92599C14.1937 5.49785 14.1093 5.0739 13.9454 4.67837C13.7815 4.28284 13.5413 3.92348 13.2385 3.62081Z",
    fill: "#6100C2",
    stroke: "#6100C2",
    strokeWidth: 1.18519,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.395d514d7710933070b5b9471e940bd2.svg";
export { ForwardRef as ReactComponent };